
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			date: new Date(),
			time: new Date(0),
		};
	},
	props: {
		hideTimePicker: {
			type: Boolean,
		},
		value: {
			type: Date as any as () => Date,
			required: true
		},
		labelTime: {
			type: [String, Object as () => { toString(): string }]
		},
		labelDate: {
			type: [String, Object as () => { toString(): string }]
		},
		disableTimePicker: Boolean,
		md: String,
		hasError: Boolean,
		// Datum en tijd naast elkaar in één rij, zonder kolom en zonder zwevend label
		inline: Boolean
	},
	computed: {
		locale(): string {
			return this.$i18n.locale;
		},
		colWidth():number {
			return (this.hideTimePicker ? 12 : 6);
		},
		computedMd():string{
			if (this.md){
				return this.md;
			}
			return "6";
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(val: Date) {
				if (val.toDateString() != this.date.toDateString() || this.getTimeString(val) != this.getTimeString(this.time)) {
					this.date = new Date();
					this.date.setFullYear(val.getFullYear(), val.getMonth(), val.getDate());
					this.time = new Date(0);
					this.time.setHours(val.getHours(), val.getMinutes(), 0, 0);
				}
			}
		},
		date(val: Date) {
			if (val.toDateString() != this.date.toTimeString()) {
				let v = new Date(this.value);
				v.setFullYear(val.getFullYear(), val.getMonth(), val.getDate());
				this.$emit("input", v);
			}
		},
		time(val: Date) {
			if (this.getTimeString(val) != this.getTimeString(this.value)) {
				let v = new Date(this.value);
				v.setHours(val.getHours(), val.getMinutes(), 0, 0);
				this.$emit("input", v);
			}
		}
	},
	methods: {
		getTimeString(date: Date) {
			return date.getHours() + ":" + date.getMinutes();
		}
	}
});
